// extracted by mini-css-extract-plugin
export default {"fsPrice":"price-module--fs-price--9b997"};